import { useState } from "react";

const useRechargeDialog = () => {
  const [dialog, setDialog] = useState({ open: false, type: null });
  const [isAnimating, setIsAnimating] = useState(false);

  const rechargeStates = {
    success: {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          fill="none"
          viewBox="0 0 24 24"
          id="verified"
        >
          <path
            fill="#C3FDF3"
            d="M10.8843 3.55009C11.2538 2.81664 12.3009 2.81664 12.6704 3.55009L13.6627 5.51966C13.8855 5.96205 14.3987 6.17461 14.8691 6.01938L16.9634 5.3283C17.7433 5.07095 18.4838 5.81139 18.2264 6.59129L17.5353 8.68561C17.3801 9.15602 17.5926 9.66917 18.035 9.89204L20.0046 10.8843C20.7381 11.2538 20.7381 12.3009 20.0046 12.6704L18.035 13.6627C17.5926 13.8855 17.3801 14.3987 17.5353 14.8691L18.2264 16.9634C18.4838 17.7433 17.7433 18.4838 16.9634 18.2264L14.8691 17.5353C14.3987 17.3801 13.8855 17.5926 13.6627 18.035L12.6704 20.0046C12.3009 20.7381 11.2538 20.7381 10.8843 20.0046L9.89204 18.035C9.66917 17.5926 9.15602 17.3801 8.68561 17.5353L6.59129 18.2264C5.81139 18.4838 5.07095 17.7433 5.3283 16.9634L6.01938 14.8691C6.17461 14.3987 5.96205 13.8855 5.51966 13.6627L3.55009 12.6704C2.81664 12.3009 2.81664 11.2538 3.55009 10.8843L5.51966 9.89204C5.96205 9.66917 6.17461 9.15602 6.01938 8.68561L5.3283 6.59129C5.07095 5.81139 5.81139 5.07095 6.59129 5.3283L8.68561 6.01938C9.15602 6.17461 9.66917 5.96205 9.89204 5.51966L10.8843 3.55009Z"
          ></path>
          <path
            stroke="#079B7F"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M9 12L11 14L15 10"
          ></path>
        </svg>
      ),
      title: "Recharge Successful...",
      message: "Your wallet balance has been updated successfully",
      btnText: "Close",
      color: "emerald",
    },
    failed: {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="42"
          viewBox="0 0 256 256"
          id="delete"
        >
          <linearGradient
            id="a"
            x1="127.999"
            x2="127.999"
            y1=".992"
            y2="252.659"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#f43f5e"></stop>
            <stop offset="1" stopColor="#e11d48"></stop>
          </linearGradient>
          <circle cx="128" cy="128.001" r="128" fill="url(#a)"></circle>
          <path
            fill="#D8D8D8"
            d="M127.999 251.748c-69.981 0-126.835-56.162-127.972-125.873-.012.708-.027 1.415-.027 2.126C0 198.693 57.307 256 127.999 256 198.693 256 256 198.693 256 128.001c0-.711-.016-1.418-.026-2.126-1.136 69.711-57.992 125.873-127.975 125.873z"
            opacity=".2"
          ></path>
          <path
            fill="#2C2C2C"
            d="m159.71 130.104 36.722-36.723c5.771-5.771 5.774-15.214 0-20.983L184.89 60.855c-5.766-5.771-15.215-5.771-20.986.001l-36.721 36.721L90.46 60.856c-5.771-5.771-15.215-5.771-20.986-.001L57.935 72.398c-5.771 5.77-5.771 15.213 0 20.983l36.722 36.723-36.722 36.722c-5.771 5.774-5.771 15.218 0 20.986l11.539 11.542c5.771 5.777 15.215 5.774 20.986 0l36.722-36.722 36.721 36.722c5.771 5.774 15.221 5.777 20.986 0l11.542-11.542c5.774-5.769 5.771-15.212 0-20.986l-36.721-36.722z"
            opacity=".1"
          ></path>
          <path
            fill="#FAFAFA"
            d="m159.71 127.271 36.722-36.724c5.771-5.77 5.774-15.214 0-20.983L184.89 58.021c-5.766-5.77-15.215-5.77-20.986.002l-36.721 36.721L90.46 58.022c-5.771-5.771-15.215-5.771-20.986-.002L57.935 69.563c-5.771 5.77-5.771 15.214 0 20.983l36.722 36.724-36.722 36.722c-5.771 5.773-5.771 15.218 0 20.986l11.539 11.542c5.771 5.776 15.215 5.773 20.986 0l36.722-36.722 36.721 36.722c5.771 5.773 15.221 5.776 20.986 0l11.542-11.542c5.774-5.769 5.771-15.213 0-20.986l-36.721-36.721z"
          ></path>
          <path
            fill="#2C2C2C"
            d="m93.239 125.854 1.417-1.418-36.721-36.723a14.754 14.754 0 0 1-4.261-9.074c-.404 4.极 1.017 8.665 4.261 11.908l35.304 35.307zm103.193-35.307c3.246-3.244 4.667-7.65 4.263-11.911a14.754 14.754 0 0 1-4.263 9.077l-36.722 36.723 1.418 1.418 35.304-35.307zm0 91.597-11.542 11.543c-5.766 5.776-15.215 5.773-20.986 0l-36.721-36.722-36.723 36.722c-5.771 5.773-15.215 5.776-20.986 0l-11.539-11.543a14.749 14.749 0 0 1-4.261-9.072c-.404 4.26 1.017 8.664 4.261 11.907l11.539 11.542c5.771 5.776 15.215 5.773 20.986 0l36.722-36.722 36.721 36.722c5.771 5.773 15.221 5.776 20.986 0l11.542-11.542c3.246-3.243 4.666-7.646 4.263-11.906a14.748 14.748 0 0 1-4.262 9.071z"
            opacity=".2"
          ></path>
        </svg>
      ),
      title: "Payment Failed...",
      message: "Your recharge attempt was unsuccessful for some reason.",
      btnText: "Close",
      color: "rose",
    },
    cancelled: {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 48 48" id="crisis">
          <path
            fill="#ffc343"
            d="M44.496,34.5L28.33,6.5c-.904-1.565-2.522-2.5-4.33-2.5s-3.426.935-4.33,2.5L3.504,34.5c-.904,1.565-.904,3.435,0,5s2.522,2.5,4.33,2.5h32.332c1.808,0,3.426-.935,4.33-2.5s.904-3.435,0-5Z"
          ></path>
          <path
            fill="#ffa221"
            d="M34,37c-10.478,0-19.383-6.718-22.656-16.079l-7.84,13.579c-.904,1.565-.904,3.435,0,5s2.522,2.5,4.33,2.5h32.332c1.808,0,3.426-.935,4.33-2.5.891-1.543.899-3.38.034-4.931-3.18,1.555-6.752,2.431-10.53,2.431Z"
          ></path>
          <path
            fill="#555e77"
            d="M24,30c1.086,0,1.986-.815,2.095-1.896l1.181-11.806c.084-.842-.193-1.685-.761-2.312-.567-.627-1.378-.987-2.224-.987h-.58c-.846,0-1.657.36-2.224.987-.568.627-.845,1.47-.761,2.312l1.181,11.806c.108,1.081,1.009,1.896,2.095,1.896Z"
          ></path>
          <circle cx="24" cy="34.5" r="3.5" fill="#555e77"></circle>
          <path
            fill="#424c63"
            d="M24,38c1.394,0,2.592-.826,3.154-2.009-2.269-.675-4.393-1.675-6.326-2.949-.206.445-.328.936-.328,1.458,0,1.93,1.57,3.5,3.5,3.5Z"
          ></path>
        </svg>
      ),
      title: "Transaction Cancelled...",
      message: "The recharge process was interrupted for some reason.",
      btnText: "Close",
      color: "amber",
    },
  };

  const closeDialog = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setDialog({ open: false, type: null });
      setIsAnimating(false);
    }, 300); // Match CSS transition duration
  };

  const RechargeDialog = () => (
    <div
      className={`
        fixed inset-0 z-50 flex items-center justify-center
        ${dialog.open || isAnimating ? "visible" : "invisible"}
      `}
    >
      {/* Backdrop */}
      <div
        className={`
          absolute inset-0 bg-black/60 backdrop-blur-md
          ${dialog.open ? "opacity-100" : "opacity-0"}
          transition-opacity duration-300 ease-in-out
        `}
        onClick={closeDialog}
      />

      {/* Dialog Content */}
      <div
        className={`
          relative bg-gray-900 rounded-[32px] p-4 md:p-6 min-w-[90%] md:min-w-[460px] max-w-3xl mx-4
          transform transition-all duration-300 ease-in-out
          ${dialog.open ? "scale-100 opacity-100" : "scale-95 opacity-0"}
          ${isAnimating && "transition-none"}
        `}
      >
        <div className="flex gap-4 items-center">
          <div
            className={`
            w-20 h-20 rounded-full flex items-center justify-center mb-6
            ${
              dialog.type === "success"
                ? "bg-emerald-500/10 text-emerald-500"
                : dialog.type === "failed"
                ? "bg-rose-500/10 text-rose-500"
                : "bg-amber-500/10 text-amber-500"
            }
          `}
            style={{
              boxShadow: `0 0 0 2px ${
                dialog.type === "success"
                  ? "rgba(16, 185, 129, 0.2)"
                  : dialog.type === "failed"
                  ? "rgba(244, 63, 94, 0.2)"
                  : "rgba(245, 158, 11, 0.2)"
              }`,
            }}
          >
            {rechargeStates[dialog.type]?.icon}

            <div
              className={`
              absolute w-10 h-10 rounded-full ${
                dialog.type === "success"
                  ? "bg-emerald-500 border-emerald-900/80"
                  : dialog.type === "failed"
                  ? "bg-rose-500 border-rose-900/80"
                  : "bg-amber-500 border-amber-900/80"
              } border-2 animate-ping
            `}
            />
          </div>
          <span
            className={`text-xl md:text-4xl pb-3 font-semibold ${
              dialog.type === "success"
                ? "text-emerald-500"
                : dialog.type === "failed"
                ? "text-rose-500"
                : "text-amber-500"
            } mb-3`}
          >
            {dialog.type === "success"
              ? "Congratulations!"
              : dialog.type === "failed"
              ? "Oops!"
              : "Attention!"}
          </span>
        </div>

        <h3 className="text-xl md:text-2xl font-semibold text-white mb-3">
          {rechargeStates[dialog.type]?.title}
        </h3>

        <p className="text-sm md:text-base text-gray-400 mb-6">
          {rechargeStates[dialog.type]?.message}
        </p>

        <button
          className={`
            w-full py-3.5 rounded-2xl font-semibold text-gray-900/90 transition-all
            ${
              dialog.type === "success"
                ? "bg-gradient-to-r from-emerald-500/80 to-emerald-500 ring-emerald-500/40"
                : dialog.type === "failed"
                ? "bg-gradient-to-r from-rose-500/80 to-rose-500 ring-rose-500/40"
                : "bg-gradient-to-r from-amber-500/80 to-amber-500 ring-amber-500/40"
            }
            active:scale-95 hover:ring-2 focus:outline-none focus:ring-2 ring-offset-2 ring-offset-gray-900
          `}
          onClick={closeDialog}
        >
          {rechargeStates[dialog.type]?.btnText}
        </button>
      </div>
    </div>
  );

  return {
    showSuccess: () => setDialog({ open: true, type: "success" }),
    showFailed: () => setDialog({ open: true, type: "failed" }),
    showCancelled: () => setDialog({ open: true, type: "cancelled" }),
    RechargeDialog,
  };
};

export default useRechargeDialog;
